import { gql } from '@apollo/client';

export const CREATE_REGION = gql`
  mutation CreateRegion($name: String!, $countries: [String]!) {
    createRegion(name: $name, countries: $countries) {
      region {
        id
        name
        countries
      }
      success
    }
  }
`;

export const UPDATE_REGION = gql`
  mutation UpdateRegion($id: ID!, $name: String, $countries: [String]) {
    updateRegion(id: $id, name: $name, countries: $countries) {
      region {
        id
        name
        countries
      }
      success
    }
  }
`;

export const DELETE_REGION = gql`
  mutation DeleteRegion($id: ID!) {
    deleteRegion(id: $id) {
      success
    }
  }
`;

// Assuming the backend expects countries as a JSON string
// If it expects a list, adjust the type accordingly (e.g., [String]!)

const UPDATE_PUBLISHER_SALES_REGION_SETTING = gql`
  mutation UpdatePublisherSalesRegionSetting($enable: Boolean!) {
    updatePublisherSalesRegionSetting(enable: $enable) {
      success
      publisher {
        id
        enableSalesByRegion
      }
    }
  }
`;

export { UPDATE_PUBLISHER_SALES_REGION_SETTING };
export default UPDATE_PUBLISHER_SALES_REGION_SETTING;
